<template>
    <div v-show="isVisible">
        <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
            {{ i18n.get('payments.payment_method') }}
        </h3>
        <div v-if="showOptions" class="mb-3rem with-flexible-parts js-lw-flexible-wrapper  js-same-content-child">
            <div class="paymentMethodsWrapper full-width">
                <div class="group-buttons-graphics">
                    <button v-for="gateway in activePaymentMethods" :key="gateway.value"
                            :class="buttonClasses(gateway)"
                            class="learnworlds-button learnworlds-element learnworlds-button-outline-brand 
                            learnworlds-button-normal nowrap pay-option-logo"
                            @click="selectPaymentMethod(gateway)"></button>
                </div>
            </div>
        </div>    
        
        <component ref="gateway" 
                   v-if="productData" 
                   :is="activeComponent" 
                   @setPaymentLoading="setPaymentLoading" 
                   @setCoupon="setCoupon" 
                   v-bind="gatewayProps()" 
                   @requestValidation="requestValidation"
                   @updateAuthenticationForm="updateAuthenticationForm"
                   ></component>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import PaymentGateways from "../../../components/payment-methods";

    export default {
        name: "PaymentMethod",
        
        data () {
            return {
                componentType: "PaymentMethod",
                rendersWithVue: true,
                selectedPaymentMethod: null,
                show: true,               
            }
        },
        
        computed:{
            ...mapState([
                'gateways',
                'activeStripeSourcePaymentMethods'
            ]),
            
            getDefaultDataStructure() {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: null,                    
                    hideCoupon: false,
                    itemVisibilitySettings: null
                }
            },
            
            paymentMethods(){
                //Check if we neeed label tranlsations
                return this.gateways.map( item => {
                    return {
                        label: item,
                        value: item};
                    
                });
            },  
            
            contextWrapper() {
                return this.hasContext("payment-manager") 
                    ? this.findNodeState(this.hasContext("payment-manager")[0].id) 
                    : null;
            },
            
            activePaymentMethod(){
                if(!this.selectedPaymentMethod){                    
                    return this.activePaymentMethods[0]?.value;                    
                }
                
                return this.selectedPaymentMethod;
            },
            
            activePaymentMethods(){
                return this.availablePaymentMethods
                    .concat(this.availableStripeSourcePaymentMethods);
            },
            
            availablePaymentMethods(){
                if(this.isSubscription(this.product.type)){
                    return this.paymentMethods
                        .filter(item => this.isStripe(item.value));
                }
                
                return this.paymentMethods;
            },
            
            availableStripeSourcePaymentMethods() {
                let methods = [];    
                
                if (typeof this.paymentMethods.find(paymentMethod => this.isStripe(paymentMethod.value)) === 'undefined') {
                    return [];
                }
                
                this.activeStripeSourcePaymentMethods.forEach(payment => {
                    methods.push({
                        label: this.capitalize(payment),
                        value: 'stripe',
                        type: payment
                    });
                });
                
                return methods;
            },
            
            showOptions(){
                return this.availablePaymentMethods.length > 1;
            },   
            
            product(){ 
                if(!this.contextWrapper){
                    return {
                        id: null,
                        type: null,
                        coupon: null
                    };
                }   
                
                return this.contextWrapper.getProduct;
            },
            
            productData(){ 
                if(!this.contextWrapper){
                    return null;
                }     
                
                return this.contextWrapper.productData;
            },
            
            checkoutData(){ 
                if(!this.contextWrapper){
                    return null;
                }   
                
                return this.contextWrapper.checkoutData;
            },
            
            billingInfo(){ 
                if(!this.contextWrapper){
                    return null;
                }  
                
                return this.contextWrapper.billingInfo;
            },
            
            activeComponent(){
                if(!this.activePaymentMethod){                    
                    return null;
                }

                let paymentMethod = this.isStripeSourcePayment(this.activePaymentMethod)
                    ? 'stripe'
                    : this.activePaymentMethod;
                
                return this.capitalize(paymentMethod) + "Gateway";
            },   
            
            isAuthoring(){
                return false;
            },
            
            isVisible(){
                return this.show && this.activePaymentMethod;
            },
            
            getHideCoupon() {
                return this.myData.hideCoupon;
            },
            
            loading(){
                return this.contextWrapper.paymentLoading;
            }
        },
        
        methods: {            
            gatewayProps(){
                return {
                    product: this.product,
                    productData: this.productData,
                    checkoutData: this.checkoutData,
                    billingInfo: this.billingInfo, 
                    isAuthoring: this.isAuthoring,
                    paymentType: this.selectedPaymentMethod,
                    hideCoupon: this.getHideCoupon,
                    loading: this.loading
                };
            },
            
            requestValidation(){
                this.contextWrapper.requestValidation();
            },
            
            validate(){
                return new Promise( (resolve, reject) => {
                    this.$refs.gateway.validate().then((e)=>{
                        console.log('Payment Method component validated');                        
                        resolve();
                    }).catch( error => {
                        console.log('Payment Method component rejected');
                        reject();
                    });

                });                          
            },
            
            initCheckout(){                
                this.$refs.gateway.initCheckout();
            },
            
            setPaymentLoading(val){                
                this.contextWrapper.setPaymentLoading(val.loading);
            },
            
            setCoupon(coupon){
                this.contextWrapper.setCoupon(coupon);
            },
            
            selectPaymentMethod(gateway){
                if(this.loading){
                    return;
                }
                
                this.selectedPaymentMethod = this.getGatewayValue(gateway);                
            },
            
            buttonClasses(gateway){
                let gatewayValue = this.getGatewayValue(gateway);
                
                let classes = {
                    selected: this.activePaymentMethod === gatewayValue
                }
                
                classes[gatewayValue] = true;
                
                return classes;
            },
            
            getGatewayValue(gateway) {
                return this.isStripeSourcePayment(gateway)
                    ? gateway.type
                    : gateway.value;
            },
            
            isStripeSourcePayment(gateway) {
                if (gateway.value && this.isStripe(gateway.value) && gateway.type) {
                    return true;
                }

                return this.activeStripeSourcePaymentMethods.includes(gateway);
            },
            
            isSubscription(productType) {
                return productType === 'subscription';
            },
            
            isStripe(method) {
                return method === 'stripe';
            },
            
            capitalize(word) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            },
            
            updateAuthenticationForm(value){                
                this.contextWrapper.updateAuthenticationForm(value);
            },
            
            setVisibility(val){
                this.show = val;
            }
        },
        
        components:{
            ...PaymentGateways
        }
    }
</script>
